import { withChildren } from '@builder.io/react'
import React from 'react'

/**
 * An empty React component that allows for child components within Builder.io.
 *
 * Use this as a generic parent container.
 *
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to be A/B tested.
 *
 * @returns {React.ReactElement} The randomly selected child component.
 */
const Container = (props: any): React.ReactElement => {
  const { children = [] } = props

  const isInIframe = () => {
    if (typeof window === 'undefined') return false
    try {
      return window.self !== window.top
    } catch (_err) {
      return true
    }
  }
  if (isInIframe()) {
    // Detect if in the builder editor iframe and show all child components for easier editing
    if (children.length === 0) return <div>Please add child components...</div>
  }

  return <div>{children}</div>
}

const builderChildren = withChildren(Container)
export default builderChildren
